<mat-accordion
  class="expand-tile"
  data-id="ExpandTile.Metric.{{ data ? data.kpiId : '' }}"
>
  <mat-expansion-panel
    class="mat-elevation-z0 expand-tile-outer"
    [disabled]="!studentGradesEnabled && !creditsEarnedEnabled"
    [(expanded)]="tableVisible"
    (opened)="openPanel()"
    (closed)="panelCollapsed()"
  >
    <mat-expansion-panel-header
      [ngClass]="{
        'expand-disabled': !studentGradesEnabled && !creditsEarnedEnabled
      }"
    >
      <tile-title
        [title]="data?.title"
        [definition]="data?.definition"
        [source]="data?.source"
        [level]="level"
        *ngIf="data"
        class="tile-title"
      ></tile-title>

      <div class="no-data-available" *ngIf="!loading && !hasOverallChartData">
        No data available
      </div>

      <div class="loading-metric-data" *ngIf="loading">
        Loading metric data...
      </div>

      <overall
        [chartData]="data.charts.overall.chartData"
        [dataPrefix]="data.dataPrefix"
        [dataSuffix]="data.dataSuffix"
        [trendSuffix]="data.trendSuffix"
        [title]="data.title"
        [upIsGood]="data.upIsGood"
        [color]="data.charts.overall.chartData[0].color"
        [entityLevel]="data.entityLevel"
        [overallSubtitle]="data.overallSubtitle"
        [studentFirstName]="studentFirstName"
        [roundTo]="data.roundTo"
        class="overall-chart"
        *ngIf="hasOverallChartData"
      ></overall>

      <sparkline-extended
        [chartData]="data.charts.trend.chartData"
        [categories]="data.charts.trend.categories"
        [dataPrefix]="data.dataPrefix"
        [dataSuffix]="data.dataSuffix"
        [subTitle]="data.charts.trend.subtitle"
        [periodicity]="data.periodicity"
        [studentFirstName]="studentFirstName"
        [roundTo]="data.roundTo"
        [min]="data.charts.trend.min"
        [max]="data.charts.trend.max"
        class="expand-tile-sparkline"
        *ngIf="
          data &&
          data.charts &&
          data.charts.trend &&
          data.charts.trend.chartData &&
          data.charts.trend.chartData[0] &&
          data.charts.trend.chartData[0].data &&
          (data.charts.trend.chartData.length > 1 ||
            data.charts.trend.chartData[0].data.length > 1)
        "
      ></sparkline-extended>

      <div
        *ngIf="
          hasOverallChartData &&
          (!data.charts.trend ||
            (data.charts.trend &&
              data.charts.trend.chartData &&
              data.charts.trend.chartData.length == 1 &&
              data.charts.trend.chartData[0] &&
              data.charts.trend.chartData[0].data &&
              data.charts.trend.chartData[0].data.length == 1))
        "
        class="no-trend-data-available"
      >
        No trend data available
      </div>
      <mat-panel-description
        *ngIf="studentGradesEnabled || creditsEarnedEnabled"
      >
        <span *ngIf="!tableVisible" class="descriptionSpan">Show more</span>
        <span *ngIf="tableVisible" class="descriptionSpan">Show less</span>
        <img
          *ngIf="!tableVisible"
          [src]="'../../assets/images/show_more_blue600.png'"
          class="toggleShowImg"
        />
        <img
          *ngIf="tableVisible"
          [src]="'../../assets/images/show_less_blue600.png'"
          class="toggleShowImg"
        />
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div class="loading-metric-data" *ngIf="loadingTable">
      Loading table data...
    </div>
    <div
      class="no-data-available"
      *ngIf="
        !loadingTable &&
        ((this.gradeYears && this.gradeYears.length == 0) || !tableData)
      "
    >
      No data available
    </div>

    <div *ngIf="studentGradesEnabled && gradeYears" class="student-grade-years">
      <div
        *ngFor="let gradeYear of gradeYears"
        (click)="selectGradeYear(gradeYear, true)"
        [ngClass]="{ 'selected-grade-year': gradeYear !== selectedGradeYear }"
        class="student-grade-year"
      >
        <span *ngIf="gradeYear === selectedGradeYear">Showing </span
        >{{ gradeYear }}
      </div>
    </div>
    <div
      *ngIf="creditsEarnedEnabled && tableData"
      class="grad-plan-name"
      data-cy="gradPlanName"
    >
      Graduation Plan: {{ graduationPlanName }}
    </div>
    <expand-tile-table
      *ngIf="studentGradesEnabled || creditsEarnedEnabled"
      [displayedColumns]="displayedColumns"
      [data]="tableData"
      #ExpandTileTable
    ></expand-tile-table>
  </mat-expansion-panel>
</mat-accordion>
